export const getSkin = state => state.layout.skin;